import React from 'react'
import MyNetwork from './MyNetworkRewards'

const NetworkInfluencer = () => {
  return (
   <MyNetwork networkList={true}  />
  )
}

export default NetworkInfluencer